import React from "react";

import Box from "../../../../../shared/Box";
import Columns, {
    LargeColumn,
    SmallColumn,
} from "../../../../../shared/Columns";
import NewHeadline from "../../../../../shared/NewHeadline";
import ContactForm from "./ContactForm";
import headerImage from "./headerUnsupported.jpg";
import * as styles from "./style.module.scss";

const UnsupportedZipcode = ({ zipcode }) => {
    return (
        <Columns sameHeight>
            <LargeColumn>
                <Box>
                    <Box.Image path={headerImage} format="full" />
                    <Box.Content>
                        <NewHeadline>
                            Um ein Angebot für die PLZ {zipcode} zu erhalten,
                            melde Dich gerne bei uns
                        </NewHeadline>
                        <p>
                            In dem von Dir ausgewählten Postleitzahl-Gebiet
                            bieten wir online kein Heizöl an.
                            <br />
                            Gern sind wir persönlich für Dich da. Bitte fülle
                            hierfür die Anfrage aus oder schicke uns eine E-Mail
                            an{" "}
                            <span className={styles.email}>
                                info.online@hoyer.de
                            </span>
                            .
                        </p>
                        <p>Wir freuen uns auf Dich!</p>
                    </Box.Content>
                </Box>
            </LargeColumn>
            <SmallColumn>
                <ContactForm zipcode={zipcode} />
            </SmallColumn>
        </Columns>
    );
};

export default UnsupportedZipcode;
